import { useEffect, useRef, useState } from 'react';
import { useSahaGunu } from '../api/queries';

/**
 * ═ TARİH ALANININ VARSAYILAN "BUGÜN"Ü — SAHA GÜNÜ (madde 302, 08.10.2026) ═
 *
 * ⚠️ **TARAYICININ GÜNÜ "BUGÜN" DEĞİLDİR.** Önce `lib/format.ts bugunIso /
 * bugunGunGirdisi` tarayıcı saatinden gün üretiyordu; sunucu ise her kararı
 * saha gününden (`yerelGun`, Europe/Istanbul) veriyordu — iki doğruluk
 * kaynağı. Türkiye'de ikisi aynı gündür; CI tarayıcısı UTC'de ve 00:00–03:00
 * (+03) arasında bir gün geridedir (run 37689702027: UI'ın açtığı kayıt
 * API'den açılanların arkasına sıralandı). Ürün sahibi kararı: varsayılan da
 * sunucudan gelir, kullanıcı tarihi yine değiştirir.
 *
 * Tek kaynak `useSahaGunu` (`GET /api/saha-gunu`). Bu kanca formun gün
 * durumunu kurar: değer gün gelene dek BOŞ, gelince bir kez dolar; kullanıcı
 * dokunduysa üstüne yazılmaz. Formlar `kaydedilebilir` koşuluna tarihi zaten
 * dahil eder — gün gelmeden düğme kapalı kalır (saniyenin altında).
 *
 * ⚠️ Ekranlar `new Date()`ten gün ÜRETMEZ (kanarya
 * `vade-tek-yuklem-envanteri.spec` — *tarayıcı günü* bölümü).
 */
export function useVarsayilanGun(): [string, (deger: string) => void] {
  const sahaGunu = useSahaGunu();
  const [gun, setGun] = useState('');
  const dokunuldu = useRef(false);
  useEffect(() => {
    if (!dokunuldu.current && gun === '' && sahaGunu.data) setGun(sahaGunu.data);
  }, [sahaGunu.data, gun]);
  const degistir = (deger: string): void => {
    dokunuldu.current = true;
    setGun(deger);
  };
  return [gun, degistir];
}
